import { useEffect, useMemo } from "react";
import useAZZKUTopics from "hooks/AZZKU/useAZZKUTopics";
import useAZZKURelations from "hooks/AZZKU/useAZZKURelations";
import useAZZKUVoivodeships from "hooks/AZZKU/useAZZKUVoivodeships";

import AZZKUResultsYears from "./components/AZZKUResultsYears";

export default function AZZKUResultsMain({
   params,
   setHeading,
   onChange
}) {

   const { d: topics } = useAZZKUTopics();
   const { d: relations } = useAZZKURelations( params.variable_id );
   const { d: voivodeships } = useAZZKUVoivodeships();

   const _heading_ = useMemo(() => {

      if ( !topics || !relations || !voivodeships ) return "";

      const heading = [];

      if ( !params.relation_id ) {
         let variable_name = "";
         for ( let topic of topics ) {
            const variable = topic.variables?.find( v => +v.value === +params.variable_id );
            if ( variable ) {
               variable_name = variable.label;
               break;
            }
         }

         variable_name && heading.push( variable_name );
      }

      if ( params.relation_id ) {
         const relation = relations?.find( r => +r.value === +params.relation_id );
         if ( !relation ) return;
         heading.push( "Relacja", relation.label );
      }

      if ( params.values_type === "raw" && !!params.years?.length ) {
         const years = [...params.years ].sort();
         heading.push( years.join(", "))
      }

      if ( params.values_type === "dynamics_change" && params.base_year && params.compare_year ) {
         heading.push( params.base_year + ", " +params.compare_year );
      }
      
      if ( params.voivodeship_ids && !!params.voivodeship_ids.length ) {
         heading.push( params.voivodeship_ids.map( id => {
            return voivodeships.find( v => +v.value === id )?.label;
         }).join(", "));
      } else heading.push( "Polska" );
      
      return heading.join(" | ");
   }, [
      topics,
      relations,
      voivodeships,
      params.variable_id,
      params.relation_id,
      params.values_type,
      params.years,
      params.base_year,
      params.compare_year,
      params.voivodeship_ids
   ]);

   useEffect(() => { setHeading( _heading_ )}, [ _heading_ ]);

   return (
      <>
         <AZZKUResultsYears
            params={ params }
            onChange={ onChange }
         /> 
      </>
   )
}